/**
 * Vuex module for contact form
 */
import debug from 'debug'

const dbg = debug('store:contacts:form:')

const actions = {
  open ({ commit }, { contact, isUpdate }) {
    dbg('Open contact form dialog')
    commit('OPEN_DIALOG', { contact, isUpdate })
  },
  close ({ commit }) {
    dbg('Close contact form dialog')
    commit('CLOSE_DIALOG')
  },
  setContact ({ commit }, contact) {
    commit('SET_CONTACT', contact)
  },
  setTabs ({ commit }, tabs) {
    commit('SET_TABS', tabs)
  },
  // fields
  setStreet ({ commit }, street) {
    commit('SET_STREET', street)
  },
  setCity ({ commit }, city) {
    commit('SET_CITY', city)
  },
  setRegion ({ commit }, region) {
    commit('SET_STATE', region)
  },
  setCountry ({ commit }, country) {
    commit('SET_COUNTRY', country)
  },
  setAddressType ({ commit }, addressType) {
    commit('SET_ADDRESS_TYPE', addressType)
  },
  setJobTitle ({ commit }, jobTitle) {
    commit('SET_JOB_TITLE', jobTitle)
  },
  setCompany ({ commit }, company) {
    commit('SET_COMPANY', company)
  },
  setFirstName ({ commit }, firstName) {
    commit('SET_FIRSTNAME', firstName)
  },
  setLastName ({ commit }, lastName) {
    commit('SET_LASTNAME', lastName)
  },
  setPhoneNumbers ({ commit }, phoneNumbers) {
    commit('SET_PHONENUMBERS', phoneNumbers)
  },
  setEmails ({ commit }, emails) {
    commit('SET_EMAILS', emails)
  },
  removeEmptyEmails ({ commit }) {
    commit('REMOVE_EMPTY_EMAILS')
  },
  setUseAsCallerid ({ commit }, useAsCallerid) {
    commit('SET_USE_AS_CALLERID', useAsCallerid)
  },
  setIsPersonal ({ commit }, isPersonal) {
    commit('SET_IS_PERSONAL', isPersonal)
  },
  setTags ({ commit }) {
    commit('SET_TAGS')
  },
  setPersonalTags ({ commit }) {
    commit('SET_PERSONAL_TAGS')
  },
  setTagsAsArray ({ commit }, tags) {
    commit('SET_TAGS_ARRAY', tags)
  },
  setPersonalTagsAsArray ({ commit }, personalTags) {
    commit('SET_PERSONAL_TAGS_ARRAY', personalTags)
  },
  setImage ({ commit }, image) {
    commit('SET_IMAGE', image)
  }
}

const mutations = {
  SET_IMAGE (state, image) {
    state.contact.image = image
  },
  SET_STREET (state, street) {
    state.contact.street = street
  },
  SET_CITY (state, city) {
    state.contact.city = city
  },
  SET_STATE (state, region) {
    state.contact.state = region
  },
  SET_COUNTRY (state, country) {
    state.contact.country = country
  },
  SET_ADDRESS_TYPE (state, addressType) {
    state.contact.addressType = addressType
  },
  SET_JOB_TITLE (state, jobTitle) {
    state.contact.jobTitle = jobTitle
  },
  SET_COMPANY (state, company) {
    state.contact.company = company
  },
  SET_FIRSTNAME (state, firstName) {
    state.contact.firstName = firstName
  },
  SET_LASTNAME (state, lastName) {
    state.contact.lastName = lastName
  },
  SET_PHONENUMBERS (state, phoneNumbers) {
    state.contact.phoneNumbers = phoneNumbers
  },
  REMOVE_EMPTY_EMAILS (state) {
    state.contact.emails = state.contact.emails.filter((item) => item.email !== '')
  },
  SET_EMAILS (state, emails) {
    state.contact.emails = emails
  },
  SET_USE_AS_CALLERID (state, useAsCallerid) {
    state.contact.useAsCallerid = useAsCallerid
  },
  SET_IS_PERSONAL (state, isPersonal) {
    state.contact.isPersonal = isPersonal
  },
  SET_TAGS (state) {
    const tagsAsString = state.contact.tagsAsArray.join(' ')
    state.contact.tags = tagsAsString
  },
  SET_PERSONAL_TAGS (state) {
    const tagsAsString = state.contact.personalTagsAsArray.join(' ')
    state.contact.personalTags = tagsAsString
  },
  SET_TAGS_ARRAY (state, tags) {
    state.contact.tagsAsArray = tags
    this.dispatch('contacts/form/setTags')
  },
  SET_PERSONAL_TAGS_ARRAY (state, personalTags) {
    state.contact.personalTagsAsArray = personalTags
    this.dispatch('contacts/form/setPersonalTags')
  },

  CLOSE_DIALOG (state) {
    state.dialog = false
    state.contact = null
    state.isPersonal = false
    state.isUpdate = false
    state.tabs = null
  },

  OPEN_DIALOG (state, { contact, isUpdate }) {
    state.contact = contact
    state.isPersonal = contact.isPersonal
    state.isUpdate = isUpdate
    state.dialog = true
  },

  SET_CONTACT (state, contact) {
    state.contact = contact
  },

  SET_TABS (state, tabs) {
    state.tabs = tabs
  }
}

const state = {
  dialog: false,
  contact: null,
  isPersonal: false,
  isUpdate: false,
  tabs: null
}

const getters = {
  dialog: state => state.dialog,
  contact: state => state.contact,
  isPersonal: state => state.isPersonal,
  isUpdate: state => state.isUpdate,
  tabs: state => state.tabs
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
